module.exports = __webpack_public_path__ + "teqbahn-assets/media/37.53dbc19d.png";